import type { Locale } from "@embedpdf/plugin-i18n";

export const faIR: Locale = {
  code: "fa",
  name: "فارسی",
  translations: {
    zoom: {
      in: "بزرگ‌نمایی",
      out: "کوچک‌نمایی",
      fitWidth: "تناسب با عرض",
      fitPage: "تناسب با صفحه",
      marquee: "بزرگ‌نمایی ناحیه",
      level: "بزرگ‌نمایی ({level}٪)",
      menu: "بزرگ‌نمایی",
    },
    page: {
      next: "صفحه بعد",
      previous: "صفحه قبل",
      rotation: "چرخش صفحه",
      settings: "تنظیمات صفحه",
      single: "تک‌صفحه",
      horizontal: "افقی",
      vertical: "عمودی",
      scrollLayout: "چیدمان پیمایش",
      spreadMode: "حالت دوصفحه‌ای",
      twoEven: "دوصفحه (زوج)",
      twoOdd: "دوصفحه (فرد)",
    },
    rotate: {
      clockwise: "چرخش به راست",
      counterClockwise: "چرخش به چپ",
    },
    pan: {
      toggle: "جابجایی",
    },
    pointer: {
      toggle: "نشانگر",
    },
    menu: {
      moreOptions: "گزینه‌های بیشتر",
      viewControls: "کنترل‌های نمایش",
      zoomControls: "کنترل‌های بزرگ‌نمایی",
    },
    mode: {
      view: "مشاهده",
      annotate: "حاشیه‌نویسی",
      shapes: "اشکال",
      insert: "درج",
      redact: "ویرایش و حذف",
      form: "فرم",
    },
    tabs: {
      overflowMenu: "منوی بیشتر",
    },
    capture: {
      screenshot: "تصویر صفحه",
    },
    selection: {
      copy: "کپی",
      copyToClipboard: "کپی در کلیپ‌بورد",
    },
    document: {
      menu: "منو",
      open: "باز کردن PDF",
      close: "بستن",
      print: "چاپ",
      export: "خروجی گرفتن",
      fullscreen: "تمام‌صفحه",
      protect: "محافظت",
    },
    panel: {
      sidebar: "نوار کناری",
      thumbnails: "تصاویر بندانگشتی",
      outline: "فهرست",
      search: "جستجو",
      comment: "دیدگاه‌ها",
      annotationStyle: "سبک حاشیه‌نویسی",
      redaction: "ویرایش و حذف",
    },
    history: {
      undo: "واگرد",
      redo: "ازنو",
    },
    insert: {
      image: "درج تصویر",
      rubberStamp: "مهر",
    },
    stamp: {
      createFromGroup: "ساخت مهر از گروه",
      createFromSelected: "ساخت مهر از انتخاب",
      rubberStamp: "مهر",
    },
    signature: {
      title: "امضا",
      ink: "امضای دستی",
      stamp: "مهر امضا",
      create: {
        title: "ساخت امضا",
      },
    },
    redaction: {
      redact: "ویرایش و حذف",
      area: "حذف ناحیه",
      text: "حذف متن",
      apply: "اعمال",
      applyAll: "اعمال همه",
      clearAll: "پاک‌کردن همه",
      commitSelected: "اعمال انتخاب‌شده‌ها",
      deleteSelected: "حذف انتخاب‌شده‌ها",
    },
    annotation: {
      highlight: "هایلایت",
      underline: "زیرخط",
      strikeout: "خط‌خورده",
      squiggly: "موج‌دار",
      text: "یادداشت متنی",
      freeText: "متن آزاد",
      ink: "قلم",
      inkHighlighter: "هایلایتر قلمی",
      line: "خط",
      arrow: "پیکان",
      rectangle: "مستطیل",
      square: "مربع",
      circle: "دایره",
      polygon: "چندضلعی",
      polyline: "خط شکسته",
      stamp: "مهر",
      comment: "دیدگاه",
      link: "پیوند",
      addLink: "افزودن پیوند",
      gotoLink: "رفتن به پیوند",
      callout: "بالن توضیح",
      caret: "نشانگر درج",
      insertText: "درج متن",
      replaceText: "جایگزینی متن",
      overlayText: "متن رویی",
      redact: "ویرایش و حذف",
      moreTools: "ابزارهای بیشتر",
      deleteSelected: "حذف انتخاب‌شده",
      deleteAllSelected: "حذف همه‌ی انتخاب‌شده‌ها",
      widgetEdit: "ویرایش فیلد",
      style: "سبک",
      strokeColor: "رنگ خط",
      fillColor: "رنگ پُرکننده",
      fontColor: "رنگ قلم",
      strokeWidth: "ضخامت خط",
      borderStyle: "سبک حاشیه",
      blendMode: "حالت ترکیب",
      opacity: "شفافیت",
      fontFamily: "قلم",
      fontSize: "اندازه‌ی قلم",
      textAlign: "ترازبندی متن",
      verticalAlign: "ترازبندی عمودی",
      lineEndings: "انتهای خط",
      rotation: "چرخش",
    },
    form: {
      textfield: "فیلد متنی",
      checkbox: "چک‌باکس",
      radio: "دکمه‌ی رادیویی",
      radiobutton: "دکمه‌ی رادیویی",
      combobox: "فهرست کشویی",
      listbox: "فهرست",
      select: "انتخاب",
      toggleFillMode: "تغییر حالت تکمیل",
    },
    protect: {
      permissions: {
        print: "چاپ",
        printHighQuality: "چاپ باکیفیت",
        copy: "کپی",
        modify: "ویرایش",
        annotations: "حاشیه‌نویسی",
        fillForms: "تکمیل فرم‌ها",
        assemble: "مونتاژ صفحات",
        accessibility: "دسترسی‌پذیری",
      },
    },
    emptyState: {
      title: "هیچ فایلی باز نشده است",
      description: "برای مشاهده، یک فایل PDF باز کنید.",
      descriptionMulti: "برای مشاهده، یک یا چند فایل PDF باز کنید.",
      openButton: "باز کردن فایل",
      supportedFormats: "فرمت پشتیبانی‌شده: PDF",
    },
  },
};
